import Svg, { SvgProps, Path } from 'react-native-svg';

export const ForwardIcon = (props: SvgProps) => (
  <Svg viewBox="0 0 24 24" width={24} height={24} fill="#FFFFFF" {...props}>
    <Path d="M7.992 3.192a.8.8 0 0 0-.558 1.374L14.87 12l-7.435 7.434a.8.8 0 1 0 1.132 1.132l8-8a.8.8 0 0 0 0-1.132l-8-8a.8.8 0 0 0-.574-.242Z" />
  </Svg>
);
